import React from "react";

const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="47" height="16" fill="none">
    <path fill="currentColor" d="M46.7 8.7a1 1 0 000-1.4L40.35.92a1 1 0 10-1.41 1.41L44.59 8l-5.66 5.66a1 1 0 001.41 1.41l6.37-6.36zM0 9h46V7H0v2z" />
  </svg>
);

export default ArrowRight;
